import React from 'react';

export default function DonutChart({ slices, size = 120 }) {
  const total = slices.reduce((s, sl) => s + sl.value, 0);
  if (total === 0) {
    return (
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle cx={size / 2} cy={size / 2} r={size / 2 - 8} fill="none" stroke="#e5e7eb" strokeWidth={16} />
        <text x={size / 2} y={size / 2 + 5} textAnchor="middle" fill="#9ca3af" fontSize={13} fontWeight={700}>0</text>
      </svg>
    );
  }
  const r = size / 2 - 8;
  const circ = 2 * Math.PI * r;
  let offset = 0;
  const arcs = slices.map((sl) => {
    const frac = sl.value / total;
    const dash = frac * circ;
    const arc = { ...sl, dash, offset };
    offset += dash;
    return arc;
  });

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} style={{ transform: 'rotate(-90deg)' }}>
      {arcs.map((arc, i) => (
        <circle
          key={i}
          cx={size / 2} cy={size / 2} r={r}
          fill="none"
          stroke={arc.color}
          strokeWidth={16}
          strokeDasharray={`${arc.dash} ${circ - arc.dash}`}
          strokeDashoffset={-arc.offset}
        />
      ))}
    </svg>
  );
}
